import * as React from 'react';
import styled from 'styled-components';

import { IconSystemV2BlogPronunciation } from '@doltech/icons/SystemV2/IconSystemV2BlogPronunciation';
import { IconSystemV2BlogPronunciationCheck } from '@doltech/icons/SystemV2/IconSystemV2BlogPronunciationCheck';
import { DolPopover } from '@doltech/ui/lib/figma/Popover/DolPopover';
import { TextLink } from '@doltech/ui/lib/figma/TextLink/TextLink';
import { TooltipContent } from './TooltipContent';
import { useFromScreens } from '@doltech/ui/lib/hooks/useDeviceQuery.hook';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

interface PronunciationProgressButtonProps {
  status?: 'not-yet' | 'done';
  onDoPronunciation?: () => void;
  onReviewPronunciation?: () => void;
}

export const PronunciationProgressButton = (props: PronunciationProgressButtonProps) => {
  const { status, onDoPronunciation, onReviewPronunciation } = props;
  const [, from1024] = useFromScreens([0, 1024]);

  switch (status) {
    case 'done':
      return (
        <Container className="pronunciation-progress-button done">
          <DolPopover
            maxWidth="300px"
            className="action-write-sentence-tooltip"
            trigger="hover"
            placement="top-end"
            overlayClassName="no-arrow custom-inner-content bordered"
            content={
              <TooltipContent
                title="Bạn đã luyện phát âm câu này"
                description="Nhấn để xem chi tiết"
              />
            }
            disabled={!from1024}
          >
            <TextLink
              color="green"
              size="medium"
              iconLeft={<IconSystemV2BlogPronunciationCheck />}
              text="Luyện shadowing câu"
              onClick={onReviewPronunciation}
            />
          </DolPopover>
        </Container>
      );
    case 'not-yet':
    default:
  }

  return (
    <Container className="pronunciation-progress-button">
      <DolPopover
        maxWidth="300px"
        className="action-write-sentence-tooltip"
        trigger="hover"
        placement="top-end"
        overlayClassName="no-arrow custom-inner-content bordered"
        content={
          <TooltipContent
            title="Bạn chưa luyện phát âm câu này"
            description="Nhấn để bắt đầu luyện tập"
          />
        }
        disabled={!from1024}
      >
        <TextLink
          color="blue"
          size="medium"
          iconLeft={<IconSystemV2BlogPronunciation />}
          text="Luyện shadowing câu"
          onClick={onDoPronunciation}
        />
      </DolPopover>
    </Container>
  );
};
